import React from 'react';
import { Link } from 'react-router-dom';
import Brand from './components/Brand';
import ThemeToggle from './components/ThemeToggle';

function TermsOfService() {
  return (
    <div className="min-h-screen bg-surface text-content">
      {/* Simple Navigation */}
      <nav className="bg-surface-2 border-b border-line sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-[72px]">
            <Brand />
            <div className="flex items-center gap-4">
              <Link to="/" className="text-content-2 hover:text-accent transition">
                ← Back to Home
              </Link>
              <ThemeToggle />
            </div>
          </div>
        </div>
      </nav>

      {/* Terms of Service Content */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-content mb-4">Terms of Service</h1>
            <p className="text-xl text-content-2">Clear, fair terms for our partnership</p>
          </div>
          
          <div className="bg-surface-2 rounded-2xl p-8 border border-line">
            <div className="space-y-6 text-content-2">
              <div>
                <h2 className="text-2xl font-bold text-content mb-4">1. Services</h2>
                <p>
                  Databurst Technologies LLC provides software engineering consultancy services including but not limited to:
                  system architecture design, software development, integration services, and technical advisory.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-content mb-4">2. Engagement Terms</h2>
                <p className="mb-3">All engagements are governed by:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Mutual Non-Disclosure Agreement (NDA)</li>
                  <li>Statement of Work (SOW) specific to each project</li>
                  <li>Master Service Agreement (MSA) when applicable</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-content mb-4">3. Intellectual Property</h2>
                <p className="mb-3">Unless otherwise specified in the SOW:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Client retains ownership of all deliverables</li>
                  <li>Databurst Technologies LLC retains rights to general methodologies and know-how</li>
                  <li>Open source contributions remain under their respective licenses</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-content mb-4">4. Confidentiality</h2>
                <p>
                  We maintain strict confidentiality of all client information. We do not share, sell, or 
                  disclose any client data, project details, or business information to third parties.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-content mb-4">5. Quality Commitment</h2>
                <p className="mb-3">We guarantee:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Professional, production-ready code</li>
                  <li>Industry best practices and standards</li>
                  <li>Comprehensive documentation</li>
                  <li>Knowledge transfer to your team</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-content mb-4">6. Limitation of Liability</h2>
                <p>
                  Liability is limited to the value of services rendered under the specific SOW.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-content mb-4">7. Termination</h2>
                <p>
                  Either party may terminate services with written notice as specified in the SOW. 
                  All work completed to date will be delivered and invoiced.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-content mb-4">8. Governing Law</h2>
                <p>
                  These terms are governed by the laws of the jurisdiction specified in the MSA or SOW.
                </p>
              </div>

              <div className="mt-8 pt-6 border-t border-line">
                <p className="text-sm text-content-2">
                  Last updated: January 2025
                </p>
                <p className="text-sm text-content-2 mt-2">
                  For questions about these terms, contact us at legal@databurst.dev
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Simple Footer */}
      <footer className="bg-surface-2 text-content py-8 mt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-content-2">
            © 2017-2026 Databurst Technologies LLC. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default TermsOfService;